import React, { useState, useEffect } from 'react';
import {
  Box,
  Button,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  TextField,
  Typography,
  Alert,
  CircularProgress,
  IconButton,
  Card,
  CardContent,
  Paper,
  Snackbar,
  Divider,
  Tooltip,
  Grid,
  Accordion,
  AccordionSummary,
  AccordionDetails,
  List,
  ListItem,
  ListItemText,
  Checkbox,
  FormControlLabel,
  LinearProgress,
  Step,
  Stepper,
  StepLabel,
  TableContainer,
  Table,
  TableHead,
  TableBody,
  TableRow,
  TableCell,
  Chip,
  Tab,
  Tabs
} from '@mui/material';
//import Grid2 from '@mui/material/Unstable_Grid2';
import { Grid as Grid2 } from '@mui/material';
import {
  Add as AddIcon,
  Upload as UploadIcon,
  Close as CloseIcon,
  Refresh as RefreshIcon,
  Download as DownloadIcon,
  Info as InfoIcon,
  ExpandMore as ExpandMoreIcon,
  Save as SaveIcon,
  Delete as DeleteIcon,
  Check as CheckIcon,
  Key as KeyIcon,
  Settings as SettingsIcon
} from '@mui/icons-material';
import { 
  DataGrid
} from '@mui/x-data-grid';
import axios from 'axios';
import Cookies from 'js-cookie'; // Import Cookies

// Import the new OtherPricesPanel component
import OtherPricesPanel from './OtherPricesPanel';
// Import TabView component
import TabView from '../shared/TabView';
import { STATUS_BAR_HEIGHT } from '../StatusBar'; // Import the status bar height constant

// Use environment variable for API key - exact same implementation as AdminPanel.js
const API_KEY = process.env.REACT_APP_API_KEY || 'UXvTRtMeXRZTtZgMNZhht_kYcLB.KcqxkVjX2.qmTQ';

// TabPanel component for tab content
function TabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`price-admin-tabpanel-${index}`}
      aria-labelledby={`price-admin-tab-${index}`}
      {...other}
      style={{ width: '100%' }}
    >
      {value === index && (
        <Box sx={{ p: 3 }}>
          {children}
        </Box>
      )}
    </div>
  );
}

const PriceAdminPanel = () => {
  const [prices, setPrices] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [uploadModal, setUploadModal] = useState(false);
  const [file, setFile] = useState(null);
  const [uploadStatus, setUploadStatus] = useState(null);
  const [snackbar, setSnackbar] = useState({
    open: false,
    message: '',
    severity: 'info'
  });
  const [totalCount, setTotalCount] = useState(0);
  const [paginationModel, setPaginationModel] = useState({
    page: 0,
    pageSize: 50,
  });
  
  // New state for CSV processing tool
  const [csvProcessingModal, setCsvProcessingModal] = useState(false);
  const [csvFile, setCsvFile] = useState(null);
  const [csvProcessingStep, setCsvProcessingStep] = useState(0);
  const [processedData, setProcessedData] = useState([]);
  const [isSaving, setIsSaving] = useState(false);
  const [processedCount, setProcessedCount] = useState(0);
  const [csvProcessingError, setCsvProcessingError] = useState(null);

  // New state for labor costs settings
  const [laborCosts, setLaborCosts] = useState({
    iOS: { nok: 850, sek: 850, dkk: 600, eur: 85 },
    iPad: { nok: 600, sek: 600, dkk: 600, eur: 60 },
    Mac: { nok: 960, sek: 960, dkk: 760, eur: 96 },
    Beats: { nok: 400, sek: 400, dkk: 300, eur: 30 },
    AirPods: { nok: 300, sek: 300, dkk: 200, eur: 30 },
    Watch: { nok: 400, sek: 400, dkk: 400, eur: 40 }
  });

  // Additional state for labor costs Excel import
  const [laborCostFile, setLaborCostFile] = useState(null);
  const [isImportingLabor, setIsImportingLabor] = useState(false);

  // Add state for freight costs
  const [freightCosts, setFreightCosts] = useState({
    // Default 2-way freight costs
    iOS: { nok: 160, sek: 160, dkk: 90.4, eur: 16 },
    iPad: { nok: 160, sek: 160, dkk: 90.4, eur: 16 },
    Mac: { nok: 224, sek: 224, dkk: 128, eur: 24 },
    Beats: { nok: 160, sek: 160, dkk: 90.4, eur: 16 },
    AirPods: { nok: 160, sek: 160, dkk: 90.4, eur: 16 },
    Watch: { nok: 160, sek: 160, dkk: 90.4, eur: 16 }
  });

  // Additional state to track which freight type is selected (1-way or 2-way)
  const [freightType, setFreightType] = useState('2way');
  
  // Add state for tab selection
  // Remove the activeTab state as TabView will handle this
  // const [activeTab, setActiveTab] = useState(0);

  // Add state for other prices modal
  const [otherPricesModal, setOtherPricesModal] = useState(false);

  // Updated auth headers function to match exactly what works in AdminPanel.js
  const getAuthHeaders = (contentType = 'application/json') => {
    const headers = { 
      'Content-Type': contentType,
      'X-API-Key': API_KEY.trim()
    };
    
    // Get JWT token from cookies
    const cookies = document.cookie.split(';');
    const tokenCookie = cookies.find(cookie => cookie.trim().startsWith('token='));
    if (tokenCookie) {
      const token = tokenCookie.split('=')[1];
      // If token contains semicolon (additional cookie information), strip it
      const cleanToken = token.includes(';') ? token.split(';')[0] : token;
      headers['Authorization'] = `Bearer ${cleanToken}`;
      console.log('Including JWT token in request');
    } else {
      console.warn('JWT token not found in cookies');
      
      // Try localStorage as fallback
      const localToken = localStorage.getItem('token');
      if (localToken) {
        headers['Authorization'] = `Bearer ${localToken}`;
        console.log('Using token from localStorage');
      }
    }
    
    // For FormData, we need to let the browser set the Content-Type correctly
    if (contentType === 'multipart/form-data') {
      delete headers['Content-Type'];
    }
    
    return headers;
  };

  // Debug the auth headers
  useEffect(() => {
    console.log("Auth headers sample:", getAuthHeaders());
    console.log("API Key being used:", API_KEY);
  }, []);

  // Fetch all prices without pagination with improved error logging
  const fetchPrices = async () => {
    setLoading(true);
    setError(null);
    
    try {
      const headers = getAuthHeaders();
      console.log("Fetching prices with headers:", headers);
      
      const response = await axios.get(
        `/priceadmin/allprices`, 
        { headers }
      );
      
      console.log("Response received:", response.data);
      
      // Add id as row id for DataGrid if not present
      const pricesWithIds = response.data.prices.map(price => ({
        ...price,
        id: price.id
      }));
      
      setPrices(pricesWithIds);
      setTotalCount(response.data.total);
    } catch (err) {
      if (axios.isAxiosError(err)) {
        const errorMsg = err.response?.data?.error || err.response?.data?.msg || err.message;
        setError(`Failed to fetch prices: ${errorMsg}`);
      } else {
        setError('An unknown error occurred');
      }
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchPrices();
  }, []); // Remove pagination dependencies since we're fetching all

  // Handle file selection for upload
  const handleFileChange = (e) => {
    setFile(e.target.files?.[0] || null);
  };

  // Handle CSV file upload with updated auth headers
  const handleUpload = async (e) => {
    e.preventDefault();
    
    if (!file) {
      setUploadStatus({ severity: 'error', message: 'Please select a file to upload' });
      return;
    }
    
    if (!file.name.endsWith('.csv') && !file.name.endsWith('.xlsx')) {
      setUploadStatus({ severity: 'error', message: 'File must be a CSV or Excel (.xlsx) file' });
      return;
    }
    
    setLoading(true);
    setUploadStatus(null);
    
    try {
      const formData = new FormData();
      formData.append('file', file);
      
      const headers = getAuthHeaders('multipart/form-data');
      console.log("Upload headers:", {...headers, 'Content-Type': 'multipart/form-data'});
      
      await axios.post('/priceadmin/prices/upload', formData, { headers });
      
      setUploadStatus({ severity: 'success', message: 'Prices imported successfully' });
      setFile(null);
      if (document.getElementById('fileUpload')) {
        document.getElementById('fileUpload').value = '';
      }
      
      // Refresh prices after upload
      setPaginationModel({ ...paginationModel, page: 0 }); // Return to first page
      fetchPrices();
      setUploadModal(false);
      
      showSnackbar('Price data uploaded and processed successfully', 'success');
    } catch (err) {
      const errorMsg = err.response?.data?.error || err.response?.data?.msg || err.message;
      setUploadStatus({
        severity: 'error',
        message: `Failed to upload prices: ${errorMsg}`
      });
      console.error('Error uploading prices:', err);
      console.error('Response details:', err.response?.data);
    } finally {
      setLoading(false);
    }
  };
  
  // Handle cell value change with updated auth headers
  const handleCellEditCommit = async (params) => {
    const { id, field, value } = params;
    if (!id || !field) return;

    const currentRow = prices.find(price => price.id === id);
    if (!currentRow || currentRow[field] === value) return;

    setLoading(true);
    
    const updatedData = {
      ...currentRow,
      [field]: value
    };
    
    const headers = getAuthHeaders();
    console.log(`Updating price ${id}, field ${field} with headers:`, headers);
    
    await axios.put(`/priceadmin/prices/${id}`, updatedData, { headers });
    
    // Update local state
    setPrices(prevPrices => 
      prevPrices.map(price => 
        price.id === id ? { ...price, [field]: value } : price
      )
    );
    
    showSnackbar(`Updated ${field.replace('_', ' ')} successfully`, 'success');
  };
  
  // Handle file selection for labor cost import
  const handleLaborCostFileChange = (e) => {
    setLaborCostFile(e.target.files?.[0] || null);
  };
  
  // Import labor costs from Excel
  const handleImportLaborCosts = async () => {
    if (!laborCostFile) {
      setCsvProcessingError('Please select an Excel file with labor costs');
      return;
    }
    
    if (!laborCostFile.name.endsWith('.xlsx') && !laborCostFile.name.endsWith('.xls')) {
      setCsvProcessingError('File must be an Excel (.xlsx or .xls) file');
      return;
    }
    
    setIsImportingLabor(true);
    setCsvProcessingError(null);
    
    try {
      const formData = new FormData();
      formData.append('file', laborCostFile);
      
      const headers = getAuthHeaders('multipart/form-data');
      
      console.log("Sending request to import labor costs");
      
      const response = await axios.post(
        '/priceadmin/import-labor-costs', 
        formData,
        { headers }
      );
      
      console.log("Import response:", response.data);
      
      if (response.data) {
        // Initialize with default values
        const newLaborCosts = {...laborCosts};
        const newFreightCosts = {...freightCosts};
        
        // Update labor costs from the server response
        if (response.data.labor_costs) {
          console.log("Received labor costs:", response.data.labor_costs);
          const importedLaborCosts = response.data.labor_costs;
          
          // Map the backend keys to frontend keys
          const keyMapping = {
            'ios': 'iOS',
            'ipad': 'iPad',
            'mac': 'Mac',
            'beats': 'Beats',
            'airpods': 'AirPods',
            'watch': 'Watch'
          };
          
          // Update labor costs with imported values for all categories
          Object.keys(keyMapping).forEach(backendKey => {
            const frontendKey = keyMapping[backendKey];
            if (importedLaborCosts[backendKey]) {
              console.log(`Updating ${frontendKey} labor costs:`, importedLaborCosts[backendKey]);
              // Make sure to copy all currency values
              newLaborCosts[frontendKey] = {
                nok: importedLaborCosts[backendKey].nok || newLaborCosts[frontendKey].nok,
                sek: importedLaborCosts[backendKey].sek || newLaborCosts[frontendKey].sek,
                dkk: importedLaborCosts[backendKey].dkk || newLaborCosts[frontendKey].dkk,
                eur: importedLaborCosts[backendKey].eur || newLaborCosts[frontendKey].eur
              };
            }
          });
        }
        
        // Update freight costs based on selected type
        const freightData = freightType === '1way' ? 
          response.data.freight_costs_1way : 
          response.data.freight_costs_2way;
          
        if (freightData) {
          console.log(`Received ${freightType} freight costs:`, freightData);
          
          // Map the backend keys to frontend keys
          const keyMapping = {
            'ios': 'iOS',
            'ipad': 'iPad',
            'mac': 'Mac',
            'beats': 'Beats',
            'airpods': 'AirPods',
            'watch': 'Watch'
          };
          
          // Update freight costs with imported values for all categories
          Object.keys(keyMapping).forEach(backendKey => {
            const frontendKey = keyMapping[backendKey];
            if (freightData[backendKey]) {
              console.log(`Updating ${frontendKey} freight costs:`, freightData[backendKey]);
              // Make sure to copy all currency values
              newFreightCosts[frontendKey] = {
                nok: freightData[backendKey].nok || newFreightCosts[frontendKey].nok,
                sek: freightData[backendKey].sek || newFreightCosts[frontendKey].sek,
                dkk: freightData[backendKey].dkk || newFreightCosts[frontendKey].dkk,
                eur: freightData[backendKey].eur || newFreightCosts[frontendKey].eur
              };
            }
          });
        }
        
        // Actually update the state with new values
        console.log("Updating state with new labor costs:", newLaborCosts);
        console.log("Updating state with new freight costs:", newFreightCosts);
        
        setLaborCosts(newLaborCosts);
        setFreightCosts(newFreightCosts);
        
        showSnackbar('Labor and freight costs imported successfully', 'success');
        setLaborCostFile(null);
        
        // Clear the file input
        if (document.getElementById('laborCostFileUpload')) {
          document.getElementById('laborCostFileUpload').value = '';
        }
      } else {
        setCsvProcessingError('No valid costs found in the file');
      }
    } catch (err) {
      const errorMsg = err.response?.data?.error || err.response?.data?.msg || err.message;
      setCsvProcessingError(`Failed to import costs: ${errorMsg}`);
      console.error('Error importing costs:', err);
    } finally {
      setIsImportingLabor(false);
    }
  };

  // Add new price
  const handleAddPrice = () => {
    // Implementation will be added later
    showSnackbar('Add price functionality coming soon', 'info');
  };
  
  // Show snackbar message
  const showSnackbar = (message, severity = 'info') => {
    setSnackbar({
      open: true,
      message,
      severity
    });
  };
  
  // Close snackbar
  const handleCloseSnackbar = () => {
    setSnackbar({
      ...snackbar,
      open: false
    });
  };
  
  // Define columns for DataGrid
  const columns = [
    { field: 'id', headerName: 'ID', width: 70, editable: false },
    { field: 'brand', headerName: 'Brand', width: 150, editable: true },
    { field: 'model', headerName: 'Model', width: 200, editable: true },
    { field: 'storage', headerName: 'Storage', width: 120, editable: true },
    { field: 'repair_type', headerName: 'Repair Type', width: 200, editable: true },
    { 
      field: 'price_nok', 
      headerName: 'NOK', 
      width: 120, 
      editable: true,
      type: 'number',
      valueFormatter: (params) => {
        if (typeof params.value === 'number') {
          return params.value.toFixed(2);
        }
        return params.value;
      }
    },
    { 
      field: 'price_sek', 
      headerName: 'SEK', 
      width: 120, 
      editable: true,
      type: 'number'
    },
    { 
      field: 'price_dkk', 
      headerName: 'DKK', 
      width: 120, 
      editable: true,
      type: 'number'
    },
    { 
      field: 'price_eur', 
      headerName: 'EUR', 
      width: 120, 
      editable: true,
      type: 'number'
    }
  ];

  // CSV Processing functions
  const handleOpenCsvProcessing = () => {
    setCsvProcessingModal(true);
    setCsvProcessingStep(0);
    setCsvFile(null);
    setProcessedData([]);
    setCsvProcessingError(null);
  };

  const handleCsvFileChange = (e) => {
    setCsvFile(e.target.files?.[0] || null);
    setProcessedData([]);
    setCsvProcessingError(null);
  };

  // Handle labor cost changes
  const handleLaborCostChange = (category, currency, value) => {
    const numValue = parseFloat(value) || 0;
    setLaborCosts(prev => ({
      ...prev,
      [category]: {
        ...prev[category],
        [currency]: numValue
      }
    }));
  };

  // Handle freight cost changes
  const handleFreightCostChange = (category, currency, value) => {
    const numValue = parseFloat(value) || 0;
    setFreightCosts(prev => ({
      ...prev,
      [category]: {
        ...prev[category],
        [currency]: numValue
      }
    }));
  };

  // Change freight type
  const handleFreightTypeChange = (event) => {
    setFreightType(event.target.value);
  };

  const handleProcessCsv = async () => {
    if (!csvFile) {
      setCsvProcessingError('Please select a CSV file');
      return;
    }
    
    if (!csvFile.name.endsWith('.csv')) {
      setCsvProcessingError('File must be a CSV file');
      return;
    }
    
    setLoading(true);
    setCsvProcessingError(null);
    
    try {
      const formData = new FormData();
      formData.append('file', csvFile);
      
      // Add labor costs to the form data with the correct keys
      Object.entries(laborCosts).forEach(([category, costs]) => {
        const categoryKey = category.toLowerCase();
        // Add each currency
        Object.entries(costs).forEach(([currency, value]) => {
          formData.append(`labor_${categoryKey}_${currency}`, value);
        });
      });
      
      // Add freight costs based on selected type
      Object.entries(freightCosts).forEach(([category, costs]) => {
        const categoryKey = category.toLowerCase();
        // Add each currency
        Object.entries(costs).forEach(([currency, value]) => {
          formData.append(`freight_${categoryKey}_${currency}`, value);
        });
      });
      
      // Add freight type selection
      formData.append('freight_type', freightType);
      
      const headers = getAuthHeaders('multipart/form-data');
      console.log("Processing CSV with headers:", headers);
      console.log("Sending labor costs:", laborCosts);
      
      // Add debugging to see what's being sent
      console.log("Sending file:", csvFile.name, csvFile.size, csvFile.type);
      
      // Load url from environment variable
      const apiURL = process.env.REACT_APP_API_URL || 'http://localhost:5000';

      // Use absolute URL to ensure correct endpoint
      const url = apiURL + '/priceadmin/process-csv';
      console.log(`Sending request to: ${url}`);
      
      const response = await axios.post(url, formData, { 
        headers,
        // Add additional axios config to help debug
        validateStatus: status => true, // Accept all status codes for debugging
        timeout: 60000, // Increase timeout to 60s
      });
      
      // Log response for debugging
      console.log("Response status:", response.status);
      console.log("Response data:", response.data);
      
      if (response.status !== 200) {
        throw new Error(`Server responded with status ${response.status}: ${response.statusText}`);
      }
      
      if (response.data && response.data.data) {
        // Convert data to format needed for DataGrid
        const dataWithIds = response.data.data.map((item, index) => ({
          ...item,
          id: index
        }));
        
        setProcessedData(dataWithIds);
        setProcessedCount(dataWithIds.length);
        setCsvProcessingStep(1); // Move to preview step
        showSnackbar(`Successfully processed ${dataWithIds.length} price entries`, 'success');
      } else {
        setCsvProcessingError('No data returned from processing');
      }
    } catch (err) {
      console.error("Error in CSV processing:", err);
      
      // Enhanced error logging
      if (axios.isAxiosError(err)) {
        console.error("Response data:", err.response?.data);
        console.error("Response status:", err.response?.status);
        console.error("Response headers:", err.response?.headers);
      } else if (err.request) {
        console.error("Request was made but no response received:", err.request);
      } else {
        console.error("Error message:", err.message);
      }
      
      const errorMsg = err.response?.data?.error || err.response?.data?.msg || err.message;
      setCsvProcessingError(`Failed to process CSV: ${errorMsg}`);
    } finally {
      setLoading(false);
    }
  };

  const handleSaveProcessedData = async () => {
    if (processedData.length === 0) {
      setCsvProcessingError('No data to save');
      return;
    }
    
    setIsSaving(true);
    setCsvProcessingError(null);
    
    try {
      const headers = getAuthHeaders();
      
      // Send the processed data to the backend to save to the database
      const response = await axios.post(
        '/priceadmin/save-processed-data', 
        { prices: processedData },
        { headers }
      );
      
      setCsvProcessingStep(2); // Move to completion step
      showSnackbar(`Successfully saved ${response.data.total_inserted} price entries to database`, 'success');
      
      // Refresh the main prices data
      fetchPrices();
    } catch (err) {
      const errorMsg = err.response?.data?.error || err.response?.data?.msg || err.message;
      setCsvProcessingError(`Failed to save data: ${errorMsg}`);
      console.error('Error saving processed data:', err);
      console.error('Response details:', err.response?.data);
    } finally {
      setIsSaving(false);
    }
  };

  const handleProcessedDataCellEdit = (params) => {
    const { id, field, value } = params;
    
    setProcessedData(prevData => 
      prevData.map(row => 
        row.id === id ? { ...row, [field]: value } : row
      )
    );
  };

  // Define columns for processed data DataGrid
  const processedDataColumns = [
    { field: 'Brand', headerName: 'Brand', width: 120, editable: true },
    { field: 'Model', headerName: 'Model', width: 180, editable: true },
    { field: 'Storage', headerName: 'Storage', width: 100, editable: true },
    { field: 'Repair', headerName: 'Repair Type', width: 180, editable: true },
    { 
      field: 'Price NOK', 
      headerName: 'NOK', 
      width: 100, 
      editable: true,
      type: 'number'
    },
    { 
      field: 'Price SEK', 
      headerName: 'SEK', 
      width: 100, 
      editable: true,
      type: 'number'
    },
    { 
      field: 'Price DKK', 
      headerName: 'DKK', 
      width: 100, 
      editable: true,
      type: 'number'
    },
    { 
      field: 'Price EUR', 
      headerName: 'EUR', 
      width: 100, 
      editable: true,
      type: 'number'
    }
  ];

// Convert labor costs to rows for DataGrid
const getLaborCostRows = () => {
  return Object.entries(laborCosts).map(([category, costs]) => ({
    id: `labor-${category}`,
    category,
    type: 'Labor',
    ...costs
  }));
};

// Convert freight costs to rows for DataGrid
const getFreightCostRows = () => {
  return Object.entries(freightCosts).map(([category, costs]) => ({
    id: `freight-${category}`,
    category,
    type: freightType === '2way' ? '2-way Freight' : '1-way Freight',
    ...costs
  }));
};

// Handle labor cost cell edit
const handleLaborCostCellEdit = (params) => {
  const { id, field, value } = params;
  if (field !== 'device') {
    handleLaborCostChange(id, field, value);
  }
};

// Handle freight cost cell edit
const handleFreightCostCellEdit = (params) => {
  const { id, field, value } = params;
  if (field !== 'device') {
    handleFreightCostChange(id, field, value);
  }
};

// Cost columns for DataGrid
const costColumns = [
  { field: 'device', headerName: 'Device', width: 120, editable: false },
  { 
    field: 'nok', 
    headerName: 'NOK', 
    width: 100, 
    editable: true,
    type: 'number'
  },
  { 
    field: 'sek', 
    headerName: 'SEK', 
    width: 100, 
    editable: true,
    type: 'number'
  },
  { 
    field: 'dkk', 
    headerName: 'DKK', 
    width: 100, 
    editable: true,
    type: 'number'
  },
  { 
    field: 'eur', 
    headerName: 'EUR', 
    width: 100, 
    editable: true,
    type: 'number'
  }
];

  // Add function to open other prices modal
  const handleOpenOtherPricesModal = () => {
    setOtherPricesModal(true);
  };

  // Define common scrollbar styling that can be reused
  const scrollbarStyling = {
    '&::-webkit-scrollbar': {
      width: '4px',
    },
    '&::-webkit-scrollbar-track': {
      background: '#252526', // Match sidebar's track color
    },
    '&::-webkit-scrollbar-thumb': {
      background: 'rgba(255, 255, 255, 0.15)', // Match sidebar's thumb color
      borderRadius: '4px',
    },
    '&::-webkit-scrollbar-thumb:hover': {
      background: 'rgba(255, 255, 255, 0.25)', // Match sidebar's hover color
    },
    // For Firefox
    scrollbarWidth: 'thin',
    scrollbarColor: 'rgba(255, 255, 255, 0.15) #252526',
  };

  // Define tab content components - this will now be nested in Apple tab
  const renderPriceDataTab = () => (
    <Box sx={{ width: '100%', display: 'flex', flexDirection: 'column' }}>
      <Box sx={{ display: 'flex', p: 2, alignItems: 'center', bgcolor: 'background.paper' }}>
        <Typography variant="h6" component="h3">
          Price Data
        </Typography>
        <Typography variant="body2" color="text.secondary" sx={{ ml: 2 }}>
          Double-click on a cell to edit
        </Typography>
        <Tooltip title="Changes are saved immediately when you press Enter or click outside the cell">
          <IconButton size="small" sx={{ ml: 1 }}>
            <InfoIcon fontSize="small" />
          </IconButton>
        </Tooltip>
      </Box>
      <Divider />
      
      <Box sx={{ 
        flexGrow: 1, 
        width: '100%', 
        height: {
          // Dynamic height calculation based on viewport
          xs: `calc(100vh - 380px - ${STATUS_BAR_HEIGHT}px)`,
          sm: `calc(100vh - 350px - ${STATUS_BAR_HEIGHT}px)`,
          md: `calc(100vh - 320px - ${STATUS_BAR_HEIGHT}px)`,
        },
        overflow: 'hidden' // Prevent container from having its own scrollbar
      }}>
        <DataGrid
          rows={prices}
          columns={columns}
          disableRowSelectionOnClick
          getRowHeight={() => 'auto'}
          loading={loading}
          processRowUpdate={(newRow, oldRow) => newRow}
          onProcessRowUpdateError={(error) => {
            console.error('Error updating row:', error);
            showSnackbar('Failed to update row', 'error');
          }}
          onCellEditStop={(params, event) => {
            if (params.reason === 'enterKeyDown' || params.reason === 'cellFocusOut') {
              handleCellEditCommit(params);
            }
          }}
          sx={{
            '& .MuiDataGrid-cell--editing': {
              bgcolor: 'rgb(255,215,115, 0.19)',
              color: '#1a3e72',
            },
            '& .Mui-error': {
              bgcolor: (theme) => `rgb(126,10,15, ${theme.palette.mode === 'dark' ? 0 : 0.1})`,
              color: (theme) => (theme.palette.mode === 'dark' ? '#ff4343' : '#750f0f'),
            },
            border: 'none',
            '& .MuiDataGrid-virtualScroller': {
              // Apply consistent scrollbar styling to match sidebar
              ...scrollbarStyling
            }
          }}
          initialState={{
            pagination: {
              paginationModel: { pageSize: 100 },
            },
            sorting: {
              sortModel: [{ field: 'brand', sort: 'asc' }],
            },
          }}
          pageSizeOptions={[25, 50, 100]}
        />
      </Box>
    </Box>
  );

  // Create the Price Management Tools section that will be included in the Apple tab
  const renderPriceManagementTools = () => (
    <Paper sx={{ mb: 3, p: 2 }}>
      <Grid container spacing={2}>
        <Grid item xs={12} md={6} lg={4}>
          <Card sx={{ height: '100%' }}>
            <CardContent>
              <Typography variant="subtitle1" component="h4" gutterBottom>
                Data Import
              </Typography>
              <Typography variant="body2" color="text.secondary" gutterBottom>
                Upload CSV/Excel file to replace price data
              </Typography>
              <Box sx={{ mt: 2, display: 'flex', flexDirection: 'column', gap: 1 }}>
                <Button
                  variant="contained"
                  color="primary"
                  startIcon={<UploadIcon />}
                  onClick={() => setUploadModal(true)}
                >
                  Direct Upload Price Data
                </Button>
                
                <Button
                  variant="outlined"
                  color="secondary"
                  startIcon={<KeyIcon />}
                  onClick={handleOpenCsvProcessing}
                >
                  Process Apple CSV
                </Button>
                
                <Button
                  variant="outlined"
                  color="info"
                  startIcon={<SettingsIcon />}
                  onClick={handleOpenOtherPricesModal}
                >
                  Labor & Freight Costs
                </Button>
              </Box>
            </CardContent>
          </Card>
        </Grid>
        
        <Grid item xs={12} md={6} lg={4}>
          <Card sx={{ height: '100%' }}>
            <CardContent>
              <Typography variant="subtitle1" component="h4" gutterBottom>
                Quick Actions
              </Typography>
              <Typography variant="body2" color="text.secondary" gutterBottom>
                Common price management tasks
              </Typography>
              <Box sx={{ mt: 2, display: 'flex', gap: 1 }}>
                <Button 
                  variant="outlined"
                  color="primary"
                  startIcon={<RefreshIcon />}
                  onClick={() => fetchPrices()}
                >
                  Refresh
                </Button>
                <Button 
                  variant="outlined"
                  color="secondary"
                  startIcon={<AddIcon />}
                  onClick={handleAddPrice}
                >
                  Add Price
                </Button>
                <Tooltip title="Export feature coming soon">
                  <Button 
                    variant="outlined" 
                    startIcon={<DownloadIcon />}
                    disabled
                  >
                    Export
                  </Button>
                </Tooltip>
              </Box>
            </CardContent>
          </Card>
        </Grid>
      </Grid>
    </Paper>
  );

  // Inner TabView content (Price Data and Other Prices)
  const innerTabLabels = ["Price Data", "Other Prices"];
  const innerTabContents = [
    renderPriceDataTab(),
    <OtherPricesPanel key="other-prices" />
  ];
  
  // Render the inner tab structure (currently only Apple)
  const renderBrandsContent = () => (
    <Box sx={{ 
      width: '100%', 
      overflow: 'visible',
      // Remove any potential causes of scrollbars
      m: 0,
      p: 0,
      boxSizing: 'border-box'
    }}>
      <TabView
        tabLabels={["Apple", "Samsung"]}
        tabContents={[
          <Box 
            key="apple-content" 
            sx={{ 
              width: '100%', 
              pt: 2, 
              overflow: 'visible',
              // Ensure Apple content doesn't cause scrollbars
              boxSizing: 'border-box',
            }}
          >
            {/* Include the Price Management Tools in the Apple tab */}
            {renderPriceManagementTools()}
            
            {/* Then show the inner tabs for Price Data and Other Prices */}
            <TabView
              tabLabels={innerTabLabels}
              tabContents={innerTabContents}
              disableUrlUpdate={true}
              customSmallDimensions={{
                minHeight: 'auto',
                maxHeight: 'none',
                overflow: 'visible',
                // Fix exact sizing issues and prevent scrollbars
                boxSizing: 'border-box',
                m: 0,
                p: 1,
                pb: 3, // Add bottom padding for content
              }}
            />
          </Box>
        ]}
        variant="small"
        disableUrlUpdate={true}
        customSmallDimensions={{
          minHeight: 'auto',
          maxHeight: 'none',
          overflow: 'visible',
          // Fix exact sizing issues and prevent scrollbars
          boxSizing: 'border-box',
          m: 0,
          p: 0,
        }}
      />
    </Box>
  );

  // Outer TabView content (Brands and potentially other categories)
  const outerTabLabels = ["Brands"];
  const outerTabContents = [renderBrandsContent()];

  return (
    <Box className="price-admin-panel" sx={{ 
      height: `calc(100% - ${STATUS_BAR_HEIGHT}px)`, // Adjust height to account for StatusBar
      minHeight: `calc(100vh - ${STATUS_BAR_HEIGHT}px - 64px)`, // Account for AppBar and StatusBar
      display: 'flex', 
      flexDirection: 'column',
      overflow: 'auto',
      pb: `${STATUS_BAR_HEIGHT + 16}px`, // Increase padding at bottom
      ...scrollbarStyling,
      // Make sure pricing admin panel gives enough space for content
      boxSizing: 'border-box',
    }}>
      <Typography variant="h4" component="h2" gutterBottom>
        Price Administration
      </Typography>

      {error && (
        <Alert 
          severity="error" 
          sx={{ mb: 3 }}
          action={
            <IconButton
              aria-label="close"
              color="inherit"
              size="small"
              onClick={() => setError(null)}
            >
              <CloseIcon fontSize="inherit" />
            </IconButton>
          }
        >
          {error}
        </Alert>
      )}

      {/* The Price Management Tools section has been moved into the Apple tab */}
      {/* Main Content - Hierarchical Tab Structure */}
      <Box sx={{ 
        flexGrow: 1, 
        width: '100%',
        display: 'flex',
        flexDirection: 'column',
        overflow: 'visible', // Set to visible to prevent unnecessary scrollbars
        // Fix exact sizing issues
        boxSizing: 'border-box',
        m: 0,
        p: 0,
      }}>
        <TabView
          tabLabels={outerTabLabels}
          tabContents={outerTabContents}
          disableUrlUpdate={true}
          customSmallDimensions={{
            minHeight: 'auto',
            maxHeight: 'none',
            overflow: 'visible',
            // Fix exact sizing issues and prevent scrollbars
            boxSizing: 'border-box',
            m: 0,
            p: 0,
            // Apply a specific fix for the "Brands" tab
            '& .brands-tab-content': {
              overflow: 'visible !important',
              boxSizing: 'border-box',
            },
          }}
        />
      </Box>

      {/* Modals remain unchanged */}
      {/* Upload Modal */}
      <Dialog open={uploadModal} onClose={() => setUploadModal(false)} maxWidth="sm" fullWidth>
        <DialogTitle>Upload Price Data</DialogTitle>
        <DialogContent>
          {uploadStatus && (
            <Alert 
              severity={uploadStatus.severity} 
              sx={{ mb: 2 }}
              action={
                <IconButton
                  aria-label="close"
                  color="inherit"
                  size="small"
                  onClick={() => setUploadStatus(null)}
                >
                  <CloseIcon fontSize="inherit" />
                </IconButton>
              }
            >
              {uploadStatus.message}
            </Alert>
          )}
          
          <Card sx={{ mb: 3, mt: 2 }}>
            <CardContent>
              <Typography variant="subtitle1" component="h4" gutterBottom>
                File Requirements
              </Typography>
              <Typography variant="body2" component="p">
                The file should have the following columns:
              </Typography>
              <Box component="ul" sx={{ pl: 2 }}>
                <li>Brand</li>
                <li>Model</li>
                <li>Repair</li>
                <li>Storage</li>
                <li>Price NOK</li>
                <li>Price SEK</li>
                <li>Price DKK</li>
                <li>Price EUR</li>
              </Box>
              <Typography variant="body2" component="p" sx={{ mt: 1, color: 'error.main', fontWeight: 'bold' }}>
                Warning: Uploading will replace all existing prices!
              </Typography>
            </CardContent>
          </Card>
          
          <form onSubmit={handleUpload}>
            <Box sx={{ mb: 3 }}>
              <Button
                variant="contained"
                component="label"
                fullWidth
              >
                Select CSV or Excel File
                <input
                  id="fileUpload"
                  type="file"
                  hidden
                  onChange={handleFileChange}
                  accept=".csv,.xlsx"
                />
              </Button>
              {file && (
                <Typography variant="body2" sx={{ mt: 1 }}>
                  Selected file: {file.name}
                </Typography>
              )}
            </Box>
          </form>
        </DialogContent>
        <DialogActions>
          <Button 
            color="inherit" 
            onClick={() => setUploadModal(false)}
          >
            Cancel
          </Button>
          <Button 
            variant="contained" 
            color="primary" 
            onClick={handleUpload}
            disabled={loading || !file}
          >
            {loading ? 'Uploading...' : 'Upload and Process'}
          </Button>
        </DialogActions>
      </Dialog>

      {/* CSV Processing Modal */}
      <Dialog 
        open={csvProcessingModal} 
        onClose={() => csvProcessingStep === 0 ? setCsvProcessingModal(false) : null}
        maxWidth="lg" 
        fullWidth
      >
        <DialogTitle>
          Process Apple Parts CSV
          {csvProcessingStep === 0 && (
            <IconButton
              aria-label="close"
              onClick={() => setCsvProcessingModal(false)}
              sx={{ position: 'absolute', right: 8, top: 8 }}
            >
              <CloseIcon />
            </IconButton>
          )}
        </DialogTitle>
        
        <DialogContent>
          {/* Stepper for CSV Processing */}
          <Stepper activeStep={csvProcessingStep} sx={{ pt: 2, pb: 4 }}>
            <Step>
              <StepLabel>Upload CSV</StepLabel>
            </Step>
            <Step>
              <StepLabel>Preview & Edit</StepLabel>
            </Step>
            <Step>
              <StepLabel>Complete</StepLabel>
            </Step>
          </Stepper>
          
          {csvProcessingError && (
            <Alert 
              severity="error" 
              sx={{ mb: 3 }}
              action={
                <IconButton
                  aria-label="close"
                  color="inherit"
                  size="small"
                  onClick={() => setCsvProcessingError(null)}
                >
                  <CloseIcon fontSize="inherit" />
                </IconButton>
              }
            >
              {csvProcessingError}
            </Alert>
          )}
          <Typography variant="body2" color="text.secondary" component="p">
            Settings for labor costs and freight calculations
          </Typography>
          
          <Grid2 container spacing={2}>
            <Grid2 item xs={12} lg={6}>
              <Typography variant="subtitle2" gutterBottom>
                Labor & Freight Cost Settings:
              </Typography>
            </Grid2>
          </Grid2>
    
          {/* Step 1: Upload CSV */}
          {csvProcessingStep === 0 && (
            <>
              <Paper elevation={2} sx={{ p: 3, mb: 3 }}>
                <Typography variant="subtitle1" gutterBottom>
                  Upload Apple Parts CSV
                </Typography>
                <Typography variant="body2" color="text.secondary" paragraph>
                  Upload the CSV file exported from Apple's parts system to generate a price list.
                  The system will process the file and extract display, battery, and other repair pricing.
                </Typography>
                
                <Box sx={{ mb: 3 }}>
                  <Button
                    variant="contained"
                    component="label"
                    fullWidth
                    startIcon={<UploadIcon />}
                  >
                    Select CSV File
                    <input
                      type="file"
                      hidden
                      onChange={handleCsvFileChange}
                      accept=".csv"
                    />
                  </Button>
                  
                  {csvFile && (
                    <Box sx={{ mt: 2, display: 'flex', alignItems: 'center', gap: 1 }}>
                      <Chip label={csvFile.name} />
                      <IconButton size="small" onClick={() => setCsvFile(null)}>
                        <CloseIcon fontSize="small" />
                      </IconButton>
                    </Box>
                  )}
                </Box>
                
                <Typography variant="subtitle2" gutterBottom>
                  What will be processed:
                </Typography>
                
                <List dense>
                  <ListItem>
                    <ListItemText 
                      primary="Display Replacements" 
                      secondary="SUR - Display prices will be calculated"
                    />
                  </ListItem>
                  <ListItem>
                    <ListItemText 
                      primary="Battery Replacements" 
                      secondary="SUR - Battery prices will be calculated"
                    />
                  </ListItem>
                  <ListItem>
                    <ListItemText 
                      primary="System Repairs" 
                      secondary="Rear System, Mid System, and Back Glass prices"
                    />
                  </ListItem>
                  <ListItem>
                    <ListItemText 
                      primary="Whole Unit Replacements" 
                      secondary="WUR prices for device swaps"
                    />
                  </ListItem>
                </List>
                
                <Typography variant="body2" color="error" sx={{ mt: 2 }}>
                  Warning: This process will generate new prices. You'll be able to review them before saving.
                  When you save, existing prices in the database will be replaced!
                </Typography>

                {/* Import button and freight type checkbox in one row */}
                <Box sx={{ mt: 4, mb: 3, display: 'flex', alignItems: 'center', gap: 2 }}>
                  <Button
                    variant="outlined"
                    component="label"
                    startIcon={<UploadIcon />}
                  >
                    Import Labor/Freight Costs
                    <input
                      id="laborCostFileUpload"
                      type="file"
                      hidden
                      onChange={handleLaborCostFileChange}
                      accept=".xlsx,.xls"
                    />
                  </Button>
                  
                  {laborCostFile && (
                    <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                      <Chip 
                        label={laborCostFile.name} 
                        size="small" 
                        onDelete={() => setLaborCostFile(null)}
                      />
                      <Button 
                        size="small" 
                        onClick={handleImportLaborCosts}
                        disabled={isImportingLabor}
                      >
                        {isImportingLabor ? 'Importing...' : 'Import'}
                      </Button>
                    </Box>
                  )}
                  
                  <FormControlLabel
                    control={
                      <Checkbox 
                        checked={freightType === '2way'}
                        onChange={(e) => setFreightType(e.target.checked ? '2way' : '1way')}
                      />
                    }
                    label="Use 2-way freight (otherwise 1-way)"
                  />
                </Box>
                
                <Typography variant="subtitle2" gutterBottom>
                  Labor & Freight Cost Settings:
                </Typography>
                
                <Grid container spacing={2}>
                  {/* iOS Costs */}
                  <Grid item xs={12} lg={6}>
                    <Paper elevation={1} sx={{ p: 2 }}>
                      <Typography variant="subtitle2" gutterBottom>
                        iOS
                      </Typography>
                      <Grid container spacing={2}>
                        <Grid item xs={12} md={6}>
                          <Typography variant="body2" gutterBottom color="text.secondary">
                            Labor Costs:
                          </Typography>
                          <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 1 }}>
                            <TextField
                              label="NOK"
                              type="number"
                              value={laborCosts.iOS.nok}
                              onChange={(e) => handleLaborCostChange('iOS', 'nok', e.target.value)}
                              size="small"
                              sx={{ width: '80px' }}
                            />
                            <TextField
                              label="SEK"
                              type="number"
                              value={laborCosts.iOS.sek}
                              onChange={(e) => handleLaborCostChange('iOS', 'sek', e.target.value)}
                              size="small"
                              sx={{ width: '80px' }}
                            />
                            <TextField
                              label="DKK"
                              type="number"
                              value={laborCosts.iOS.dkk}
                              onChange={(e) => handleLaborCostChange('iOS', 'dkk', e.target.value)}
                              size="small"
                              sx={{ width: '80px' }}
                            />
                            <TextField
                              label="EUR"
                              type="number"
                              value={laborCosts.iOS.eur}
                              onChange={(e) => handleLaborCostChange('iOS', 'eur', e.target.value)}
                              size="small"
                              sx={{ width: '80px' }}
                            />
                          </Box>
                        </Grid>
                        <Grid item xs={12} md={6}>
                          <Typography variant="body2" gutterBottom color="text.secondary">
                            {freightType === '2way' ? '2-way' : '1-way'} Freight:
                          </Typography>
                          <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 1 }}>
                            <TextField
                              label="NOK"
                              type="number"
                              value={freightCosts.iOS.nok}
                              onChange={(e) => handleFreightCostChange('iOS', 'nok', e.target.value)}
                              size="small"
                              sx={{ width: '80px' }}
                            />
                            <TextField
                              label="SEK"
                              type="number"
                              value={freightCosts.iOS.sek}
                              onChange={(e) => handleFreightCostChange('iOS', 'sek', e.target.value)}
                              size="small"
                              sx={{ width: '80px' }}
                            />
                            <TextField
                              label="DKK"
                              type="number"
                              value={freightCosts.iOS.dkk}
                              onChange={(e) => handleFreightCostChange('iOS', 'dkk', e.target.value)}
                              size="small"
                              sx={{ width: '80px' }}
                            />
                            <TextField
                              label="EUR"
                              type="number"
                              value={freightCosts.iOS.eur}
                              onChange={(e) => handleFreightCostChange('iOS', 'eur', e.target.value)}
                              size="small"
                              sx={{ width: '80px' }}
                            />
                          </Box>
                        </Grid>
                      </Grid>
                    </Paper>
                  </Grid>

                  {/* iPad Costs */}
                  <Grid item xs={12} lg={6}>
                    <Paper elevation={1} sx={{ p: 2 }}>
                      <Typography variant="subtitle2" gutterBottom>
                        iPad
                      </Typography>
                      <Grid container spacing={2}>
                        <Grid item xs={12} md={6}>
                          <Typography variant="body2" gutterBottom color="text.secondary">
                            Labor Costs:
                          </Typography>
                          <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 1 }}>
                            <TextField
                              label="NOK"
                              type="number"
                              value={laborCosts.iPad.nok}
                              onChange={(e) => handleLaborCostChange('iPad', 'nok', e.target.value)}
                              size="small"
                              sx={{ width: '80px' }}
                            />
                            <TextField
                              label="SEK"
                              type="number"
                              value={laborCosts.iPad.sek}
                              onChange={(e) => handleLaborCostChange('iPad', 'sek', e.target.value)}
                              size="small"
                              sx={{ width: '80px' }}
                            />
                            <TextField
                              label="DKK"
                              type="number"
                              value={laborCosts.iPad.dkk}
                              onChange={(e) => handleLaborCostChange('iPad', 'dkk', e.target.value)}
                              size="small"
                              sx={{ width: '80px' }}
                            />
                            <TextField
                              label="EUR"
                              type="number"
                              value={laborCosts.iPad.eur}
                              onChange={(e) => handleLaborCostChange('iPad', 'eur', e.target.value)}
                              size="small"
                              sx={{ width: '80px' }}
                            />
                          </Box>
                        </Grid>
                        <Grid item xs={12} md={6}>
                          <Typography variant="body2" gutterBottom color="text.secondary">
                            {freightType === '2way' ? '2-way' : '1-way'} Freight:
                          </Typography>
                          <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 1 }}>
                            <TextField
                              label="NOK"
                              type="number"
                              value={freightCosts.iPad.nok}
                              onChange={(e) => handleFreightCostChange('iPad', 'nok', e.target.value)}
                              size="small"
                              sx={{ width: '80px' }}
                            />
                            <TextField
                              label="SEK"
                              type="number"
                              value={freightCosts.iPad.sek}
                              onChange={(e) => handleFreightCostChange('iPad', 'sek', e.target.value)}
                              size="small"
                              sx={{ width: '80px' }}
                            />
                            <TextField
                              label="DKK"
                              type="number"
                              value={freightCosts.iPad.dkk}
                              onChange={(e) => handleFreightCostChange('iPad', 'dkk', e.target.value)}
                              size="small"
                              sx={{ width: '80px' }}
                            />
                            <TextField
                              label="EUR"
                              type="number"
                              value={freightCosts.iPad.eur}
                              onChange={(e) => handleFreightCostChange('iPad', 'eur', e.target.value)}
                              size="small"
                              sx={{ width: '80px' }}
                            />
                          </Box>
                        </Grid>
                      </Grid>
                    </Paper>
                  </Grid>

                  {/* Mac Costs */}
                  <Grid item xs={12} lg={6}>
                    <Paper elevation={1} sx={{ p: 2 }}>
                      <Typography variant="subtitle2" gutterBottom>
                        Mac
                      </Typography>
                      <Grid container spacing={2}>
                        <Grid item xs={12} md={6}>
                          <Typography variant="body2" gutterBottom color="text.secondary">
                            Labor Costs:
                          </Typography>
                          <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 1 }}>
                            <TextField
                              label="NOK"
                              type="number"
                              value={laborCosts.Mac.nok}
                              onChange={(e) => handleLaborCostChange('Mac', 'nok', e.target.value)}
                              size="small"
                              sx={{ width: '80px' }}
                            />
                            <TextField
                              label="SEK"
                              type="number"
                              value={laborCosts.Mac.sek}
                              onChange={(e) => handleLaborCostChange('Mac', 'sek', e.target.value)}
                              size="small"
                              sx={{ width: '80px' }}
                            />
                            <TextField
                              label="DKK"
                              type="number"
                              value={laborCosts.Mac.dkk}
                              onChange={(e) => handleLaborCostChange('Mac', 'dkk', e.target.value)}
                              size="small"
                              sx={{ width: '80px' }}
                            />
                            <TextField
                              label="EUR"
                              type="number"
                              value={laborCosts.Mac.eur}
                              onChange={(e) => handleLaborCostChange('Mac', 'eur', e.target.value)}
                              size="small"
                              sx={{ width: '80px' }}
                            />
                          </Box>
                        </Grid>
                        <Grid item xs={12} md={6}>
                          <Typography variant="body2" gutterBottom color="text.secondary">
                            {freightType === '2way' ? '2-way' : '1-way'} Freight:
                          </Typography>
                          <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 1 }}>
                            <TextField
                              label="NOK"
                              type="number"
                              value={freightCosts.Mac.nok}
                              onChange={(e) => handleFreightCostChange('Mac', 'nok', e.target.value)}
                              size="small"
                              sx={{ width: '80px' }}
                            />
                            <TextField
                              label="SEK"
                              type="number"
                              value={freightCosts.Mac.sek}
                              onChange={(e) => handleFreightCostChange('Mac', 'sek', e.target.value)}
                              size="small"
                              sx={{ width: '80px' }}
                            />
                            <TextField
                              label="DKK"
                              type="number"
                              value={freightCosts.Mac.dkk}
                              onChange={(e) => handleFreightCostChange('Mac', 'dkk', e.target.value)}
                              size="small"
                              sx={{ width: '80px' }}
                            />
                            <TextField
                              label="EUR"
                              type="number"
                              value={freightCosts.Mac.eur}
                              onChange={(e) => handleFreightCostChange('Mac', 'eur', e.target.value)}
                              size="small"
                              sx={{ width: '80px' }}
                            />
                          </Box>
                        </Grid>
                      </Grid>
                    </Paper>
                  </Grid>

                  {/* Beats Costs */}
                  <Grid item xs={12} lg={6}>
                    <Paper elevation={1} sx={{ p: 2 }}>
                      <Typography variant="subtitle2" gutterBottom>
                        Beats
                      </Typography>
                      <Grid container spacing={2}>
                        <Grid item xs={12} md={6}>
                          <Typography variant="body2" gutterBottom color="text.secondary">
                            Labor Costs:
                          </Typography>
                          <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 1 }}>
                            <TextField
                              label="NOK"
                              type="number"
                              value={laborCosts.Beats.nok}
                              onChange={(e) => handleLaborCostChange('Beats', 'nok', e.target.value)}
                              size="small"
                              sx={{ width: '80px' }}
                            />
                            <TextField
                              label="SEK"
                              type="number"
                              value={laborCosts.Beats.sek}
                              onChange={(e) => handleLaborCostChange('Beats', 'sek', e.target.value)}
                              size="small"
                              sx={{ width: '80px' }}
                            />
                            <TextField
                              label="DKK"
                              type="number"
                              value={laborCosts.Beats.dkk}
                              onChange={(e) => handleLaborCostChange('Beats', 'dkk', e.target.value)}
                              size="small"
                              sx={{ width: '80px' }}
                            />
                            <TextField
                              label="EUR"
                              type="number"
                              value={laborCosts.Beats.eur}
                              onChange={(e) => handleLaborCostChange('Beats', 'eur', e.target.value)}
                              size="small"
                              sx={{ width: '80px' }}
                            />
                          </Box>
                        </Grid>
                        <Grid item xs={12} md={6}>
                          <Typography variant="body2" gutterBottom color="text.secondary">
                            {freightType === '2way' ? '2-way' : '1-way'} Freight:
                          </Typography>
                          <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 1 }}>
                            <TextField
                              label="NOK"
                              type="number"
                              value={freightCosts.Beats.nok}
                              onChange={(e) => handleFreightCostChange('Beats', 'nok', e.target.value)}
                              size="small"
                              sx={{ width: '80px' }}
                            />
                            <TextField
                              label="SEK"
                              type="number"
                              value={freightCosts.Beats.sek}
                              onChange={(e) => handleFreightCostChange('Beats', 'sek', e.target.value)}
                              size="small"
                              sx={{ width: '80px' }}
                            />
                            <TextField
                              label="DKK"
                              type="number"
                              value={freightCosts.Beats.dkk}
                              onChange={(e) => handleFreightCostChange('Beats', 'dkk', e.target.value)}
                              size="small"
                              sx={{ width: '80px' }}
                            />
                            <TextField
                              label="EUR"
                              type="number"
                              value={freightCosts.Beats.eur}
                              onChange={(e) => handleFreightCostChange('Beats', 'eur', e.target.value)}
                              size="small"
                              sx={{ width: '80px' }}
                            />
                          </Box>
                        </Grid>
                      </Grid>
                    </Paper>
                  </Grid>

                  {/* AirPods Costs */}
                  <Grid item xs={12} lg={6}>
                    <Paper elevation={1} sx={{ p: 2 }}>
                      <Typography variant="subtitle2" gutterBottom>
                        AirPods
                      </Typography>
                      <Grid container spacing={2}>
                        <Grid item xs={12} md={6}>
                          <Typography variant="body2" gutterBottom color="text.secondary">
                            Labor Costs:
                          </Typography>
                          <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 1 }}>
                            <TextField
                              label="NOK"
                              type="number"
                              value={laborCosts.AirPods.nok}
                              onChange={(e) => handleLaborCostChange('AirPods', 'nok', e.target.value)}
                              size="small"
                              sx={{ width: '80px' }}
                            />
                            <TextField
                              label="SEK"
                              type="number"
                              value={laborCosts.AirPods.sek}
                              size="small"
                              sx={{ width: '80px' }}
                            />
                          </Box>
                        </Grid>
                        <Grid item xs={12} md={6}>
                          <Typography variant="body2" gutterBottom color="text.secondary">
                            {freightType === '2way' ? '2-way' : '1-way'} Freight:
                          </Typography>
                          <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 1 }}>
                            <TextField
                              label="NOK"
                              type="number"
                              value={freightCosts.AirPods.nok}
                              onChange={(e) => handleFreightCostChange('AirPods', 'nok', e.target.value)}
                              size="small"
                              sx={{ width: '80px' }}
                            />
                            <TextField
                              label="SEK"
                              type="number"
                              value={freightCosts.AirPods.sek}
                              onChange={(e) => handleFreightCostChange('AirPods', 'sek', e.target.value)}
                              size="small"
                              sx={{ width: '80px' }}
                            />
                            <TextField
                              label="DKK"
                              type="number"
                              value={freightCosts.AirPods.dkk}
                              onChange={(e) => handleFreightCostChange('AirPods', 'dkk', e.target.value)}
                              size="small"
                              sx={{ width: '80px' }}
                            />
                            <TextField
                              label="EUR"
                              type="number"
                              value={freightCosts.AirPods.eur}
                              onChange={(e) => handleFreightCostChange('AirPods', 'eur', e.target.value)}
                              size="small"
                              sx={{ width: '80px' }}
                            />
                          </Box>
                        </Grid>
                      </Grid>
                    </Paper>
                  </Grid>

                  {/* Watch Costs */}
                  <Grid item xs={12} lg={6}>
                    <Paper elevation={1} sx={{ p: 2 }}>
                      <Typography variant="subtitle2" gutterBottom>
                        Watch
                      </Typography>
                      <Grid container spacing={2}>
                        <Grid item xs={12} md={6}>
                          <Typography variant="body2" gutterBottom color="text.secondary">
                            Labor Costs:
                          </Typography>
                          <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 1 }}>
                            <TextField
                              label="NOK"
                              type="number"
                              value={laborCosts.Watch.nok}
                              onChange={(e) => handleLaborCostChange('Watch', 'nok', e.target.value)}
                              size="small"
                              sx={{ width: '80px' }}
                            />
                            <TextField
                              label="SEK"
                              type="number"
                              value={laborCosts.Watch.sek}
                              onChange={(e) => handleLaborCostChange('Watch', 'sek', e.target.value)}
                              size="small"
                              sx={{ width: '80px' }}
                            />
                            <TextField
                              label="DKK"
                              type="number"
                              value={laborCosts.Watch.dkk}
                              onChange={(e) => handleLaborCostChange('Watch', 'dkk', e.target.value)}
                              size="small"
                              sx={{ width: '80px' }}
                            />
                            <TextField
                              label="EUR"
                              type="number"
                              value={laborCosts.Watch.eur}
                              onChange={(e) => handleLaborCostChange('Watch', 'eur', e.target.value)}
                              size="small"
                              sx={{ width: '80px' }}
                            />
                          </Box>
                        </Grid>
                        <Grid item xs={12} md={6}>
                          <Typography variant="body2" gutterBottom color="text.secondary">
                            {freightType === '2way' ? '2-way' : '1-way'} Freight:
                          </Typography>
                          <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 1 }}>
                            <TextField
                              label="NOK"
                              type="number"
                              value={freightCosts.Watch.nok}
                              onChange={(e) => handleFreightCostChange('Watch', 'nok', e.target.value)}
                              size="small"
                              sx={{ width: '80px' }}
                            />
                            <TextField
                              label="SEK"
                              type="number"
                              value={freightCosts.Watch.sek}
                              onChange={(e) => handleFreightCostChange('Watch', 'sek', e.target.value)}
                              size="small"
                              sx={{ width: '80px' }}
                            />
                            <TextField
                              label="DKK"
                              type="number"
                              value={freightCosts.Watch.dkk}
                              onChange={(e) => handleFreightCostChange('Watch', 'dkk', e.target.value)}
                              size="small"
                              sx={{ width: '80px' }}
                            />
                            <TextField
                              label="EUR"
                              type="number"
                              value={freightCosts.Watch.eur}
                              onChange={(e) => handleFreightCostChange('Watch', 'eur', e.target.value)}
                              size="small"
                              sx={{ width: '80px' }}
                            />
                          </Box>
                        </Grid>
                      </Grid>
                    </Paper>
                  </Grid>
                </Grid>
              </Paper>
              
              <Button 
                variant="contained" 
                color="primary" 
                onClick={handleProcessCsv}
                disabled={!csvFile || loading}
                startIcon={loading ? <CircularProgress size={20} /> : <UploadIcon />}
                fullWidth
              >
                {loading ? 'Processing...' : 'Process CSV File'}
              </Button>
            </>
          )}
          
          {/* Step 2: Preview & Edit */}
          {csvProcessingStep === 1 && (
            <>
              <Paper sx={{ p: 2, mb: 3 }}>
                <Typography variant="subtitle1" gutterBottom>
                  Processed {processedCount} Price Entries
                </Typography>
                <Typography variant="body2" color="text.secondary" paragraph>
                  Review and edit the processed data below. You can modify any cell by double-clicking it.
                  When ready, click "Save to Database" to replace existing price data.
                </Typography>
                
                <Accordion sx={{ mb: 2 }}>
                  <AccordionSummary expandIcon={<ExpandMoreIcon />}>
                    <Typography variant="subtitle2">
                      How were these prices calculated?
                    </Typography>
                  </AccordionSummary>
                  <AccordionDetails>
                    <Typography variant="body2" paragraph>
                      The system processes the CSV file from Apple and applies the following:
                    </Typography>
                    <TableContainer component={Paper} variant="outlined">
                      <Table size="small">
                        <TableHead>
                          <TableRow>
                            <TableCell>Repair Type</TableCell>
                            <TableCell>Base Price</TableCell>
                            <TableCell>Labor</TableCell>
                            <TableCell>VAT</TableCell>
                            <TableCell>Currency Conversion</TableCell>
                          </TableRow>
                        </TableHead>
                        <TableBody>
                          <TableRow>
                            <TableCell>Display</TableCell>
                            <TableCell>Part Price</TableCell>
                            <TableCell>
                              + {laborCosts.iOS.nok} NOK / {laborCosts.iOS.sek} SEK / {laborCosts.iOS.dkk} DKK / {laborCosts.iOS.eur} EUR
                            </TableCell>
                            <TableCell>+ 25%</TableCell>
                            <TableCell>SEK: x0.91, DKK: x0.67, EUR: x0.0817</TableCell>
                          </TableRow>
                          <TableRow>
                            <TableCell>Battery</TableCell>
                            <TableCell>Part Price</TableCell>
                            <TableCell>
                              + {laborCosts.iOS.nok} NOK / {laborCosts.iOS.sek} SEK / {laborCosts.iOS.dkk} DKK / {laborCosts.iOS.eur} EUR
                            </TableCell>
                            <TableCell>+ 25%</TableCell>
                            <TableCell>SEK: x0.91, DKK: x0.67, EUR: x0.0817</TableCell>
                          </TableRow>
                          <TableRow>
                            <TableCell>Freight ({freightType})</TableCell>
                            <TableCell>-</TableCell>
                            <TableCell>
                              {freightCosts.iOS.nok} NOK / {freightCosts.iOS.sek} SEK / {freightCosts.iOS.dkk} DKK / {freightCosts.iOS.eur} EUR
                            </TableCell>
                            <TableCell>+ 25%</TableCell>
                            <TableCell>Applied per device category</TableCell>
                          </TableRow>
                        </TableBody>
                      </Table>
                    </TableContainer>
                  </AccordionDetails>
                </Accordion>
              </Paper>
              
              <Box sx={{ 
                height: `500px`, 
                width: '100%', 
                mb: 3,
                overflow: 'hidden'  // Prevent container from having its own scrollbar
              }}>
                <DataGrid
                  rows={processedData}
                  columns={processedDataColumns}
                  disableRowSelectionOnClick
                  getRowHeight={() => 'auto'}
                  paginationModel={{ page: 0, pageSize: 25 }}
                  pageSizeOptions={[10, 25, 50, 100]}
                  processRowUpdate={(newRow, oldRow) => {
                    handleProcessedDataCellEdit({
                      id: newRow.id,
                      field: Object.keys(newRow).find(key => newRow[key] !== oldRow[key]),
                      value: newRow[Object.keys(newRow).find(key => newRow[key] !== oldRow[key])]
                    });
                    return newRow;
                  }}
                  onProcessRowUpdateError={(error) => {
                    console.error('Error updating row:', error);
                    showSnackbar('Failed to update row', 'error');
                  }}
                  sx={{
                    '& .MuiDataGrid-cell--editing': {
                      bgcolor: 'rgb(255,215,115, 0.19)',
                      color: '#1a3e72',
                    },
                    '& .MuiDataGrid-virtualScroller': {
                      // Apply consistent scrollbar styling to match sidebar
                      ...scrollbarStyling 
                    }
                  }}
                />
              </Box>
              
              <Box sx={{ display: 'flex', justifyContent: 'space-between' }}>
                <Button 
                  variant="outlined" 
                  onClick={() => setCsvProcessingStep(0)}
                  startIcon={<KeyIcon />}
                >
                  Back to Upload
                </Button>
                
                <Button 
                  variant="contained" 
                  color="primary" 
                  onClick={handleSaveProcessedData}
                  disabled={processedData.length === 0 || isSaving}
                  startIcon={isSaving ? <CircularProgress size={20} /> : <SaveIcon />}
                >
                  {isSaving ? 'Saving...' : 'Save to Database'}
                </Button>
              </Box>
            </>
          )}
          
          {/* Step 3: Complete */}
          {csvProcessingStep === 2 && (
            <Box sx={{ textAlign: 'center', py: 3 }}>
              <CheckIcon sx={{ fontSize: 60, color: 'success.main', mb: 2 }} />
              
              <Typography variant="h5" gutterBottom>
                Price Data Saved Successfully
              </Typography>
              
              <Typography variant="body1" paragraph>
                {processedCount} price entries have been saved to the database.
              </Typography>
              
              <Button 
                variant="contained" 
                color="primary" 
                onClick={() => setCsvProcessingModal(false)}
                sx={{ mt: 2 }}
              >
                Close
              </Button>
            </Box>
          )}
        </DialogContent>
        
        {csvProcessingStep !== 2 && (
          <DialogActions>
            {csvProcessingStep === 0 && (
              <Button color="inherit" onClick={() => setCsvProcessingModal(false)}>
                Cancel
              </Button>
            )}
          </DialogActions>
        )}
      </Dialog>

      {/* Add Other Prices Modal */}
      <OtherPricesPanel
        open={otherPricesModal}
        onClose={() => setOtherPricesModal(false)}
        isModal={true}
        onPricesUpdated={(updatedPrices) => {
          console.log('Prices updated:', updatedPrices);
          // Optionally do something with the updated prices
        }}
      />

      {/* Snackbar for notifications */}
      <Snackbar
        open={snackbar.open}
        autoHideDuration={6000}
        onClose={handleCloseSnackbar}
        anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
      >
        <Alert 
          onClose={handleCloseSnackbar} 
          severity={snackbar.severity}
          sx={{ width: '100%' }}
        >
          {snackbar.message}
        </Alert>
      </Snackbar>
    </Box>
  );
};

export default PriceAdminPanel;